import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchGRinput, downloadFile } from '../../State/actions/sessions';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Heading from 'grommet/components/Heading';
import ZoomIn from 'grommet/components/icons/base/ZoomIn';
import ZoomOut from 'grommet/components/icons/base/ZoomOut';
import Revert from 'grommet/components/icons/base/Revert';
import OverviewIcon from 'grommet/components/icons/base/Overview';
import Print from 'grommet/components/icons/base/Print';
import Save from 'grommet/components/icons/base/Save';
//import GRInputRack from '../../Datafiles/GRInput.json';
import RackDetails from './RackDetails';
import html2canvas from 'html2canvas';
import ReactTooltip from 'react-tooltip';
import Paragraph from 'grommet/components/Paragraph';
import { _said } from '../../SizerUI/SizerConfig/Config.js';
import Spinning from 'grommet/components/icons/Spinning';
import Layer from 'grommet/components/Layer';
import $ from 'jquery';
import { serviceUrl, appUrl } from '../../AppConfig';

let RackServersPresentation;
var FrontView;
let RacksInsideServers;
let EventTopspace;
let RacksDisplaying;
let EventLeftspace;
var HoverTitleStyle;
var RackHeight;
let RearviewHOverItems;
var RackInnerHeight;
var CountNewWindowOpen = 0;
var RackNote;
let SSETSolutionName='Solution Layout';
const EPAvNext = "EPAvNext";
const DisplayName = "@DisplayName";
const ToolTip = "@ToolTip";
const EmptyImage = "@EmptyImage";
class GrRackServerInnerPresentation extends Component {
    constructor() {
        super();
        this.state = {
            scaleRadiusX: 1,
            scaleRadiusY: 1,
            disabledZoomOut: false,
            disabledZoomIn: false,
            RackInnerView: false,
            RackRearView: true,
            ViewLabelbtn: 'Rear View',
            ActiveSite: '',
            TopAlignServer: '',
            TitleDisplay: false,
            ServerItemName: 'D123467',
            MinRackHeight: 700,
            rackNoteDisplay: true,
        }
        this.ZoomIn = this.ZoomIn.bind(this);
        this.ZoomOut = this.ZoomOut.bind(this);
        this.RearView = this.RearView.bind(this);
        this.RevertBack = this.RevertBack.bind(this);
        this.OuterLayerLoop = this.OuterLayerLoop.bind(this);
        this.PrintImage = this.PrintImage.bind(this);
        this.PrintImageURI = this.PrintImageURI.bind(this);
        this.VoucherSourcetoPrint = this.VoucherSourcetoPrint.bind(this);
        this.downloadPDF = this.downloadPDF.bind(this);
        this.GRHoverTextUpdate = this.GRHoverTextUpdate.bind(this);        
    }
    PrintImage() {
        this.setState({ scaleRadiusX: 0.6, MinRackHeight: 600, scaleRadiusY: 0.5, rackNoteDisplay: false });
        CountNewWindowOpen++;
        $(".RackImageDisplay").css({ "marginBottom": "200px", "marginTop": "85px", });
        html2canvas(document.querySelector("#capture")).then(canvas => {
            this.PrintImageURI(canvas.toDataURL(), 'Solution.png');
        });
    }
    PrintImageURI(url, filename) {
        var Pagelink = "about:blank";
        var pwa = window.open(Pagelink, "_new");
        pwa.document.open();
        pwa.document.write(this.VoucherSourcetoPrint(url));
        pwa.document.close();
    }
    VoucherSourcetoPrint(url) {
        return "<html><head><script>function step1(){\n" +
            "setTimeout('step2()', 10);}\n" +
            "function step2(){window.print();window.close()}\n" +
            "</script></head><body onload='step1()'>\n" +
            "<img style='width:100%,height:100%' src='" + url + "'}} /></body></html>";
    }

    GRHoverTextUpdate(product) {        
        if(product[DisplayName]!== undefined) {
            return product[DisplayName];
        } else {
            return _said === EPAvNext && product[ToolTip] !== undefined ? product[ToolTip] : product[EmptyImage].slice(0, -4);
        }
    }

    downloadPDF(format) {
        const isRearView = this.state.RackRearView ? false : true;
        let pdfName, sessionId;
        if (this.props.isFromExternalApp) {
            sessionId = this.props.externalAppProps.sizerReference;
            pdfName = SSETSolutionName;
        } else {
            sessionId = this.props.activeSession.id;
            pdfName = this.props.activeSession.alias;
        }

        pdfName += " " + ((Date().substr(4)).split('GMT'))[0] + ".pdf";

        let pdfUrl = serviceUrl + "SizingEngine/GenerateGRpdf?&sessionId=" + sessionId + "&name=" + pdfName.replace('#', '-') + "&isRearView=" + isRearView;

        if (this.props.activeSession.EPAArray && this.props.activeSession.EPAArray.length > 0) {
            pdfUrl += "&EPASolutionType=" + this.props.actvSoln;
        }

        var data = {
            url: pdfUrl,
            name: pdfName
        }
        this.props.onPDFExport(data);
    }
    OuterLayerLoop(idx) {
        if (Array.isArray(this.state.GrInputRearView.OuterLayer)) {
            if (this.props.PassActiveSite["@SiteID"] == undefined) {
                FrontView = this.state.GrInputRearView.OuterLayer[idx]
            }
            else {
                FrontView = this.state.GrInputRearView.OuterLayer[this.props.PassActiveSite["@SiteID"]];
            }
        } else {
            FrontView = this.state.GrInputRearView.OuterLayer
        }
        if (Array.isArray(FrontView.InnerLayers.InnerLayer)) {
            RacksInsideServers = FrontView.InnerLayers.InnerLayer.map(val => {
                let Server;
                var InnerServrsHeight = parseInt(val["@Height"].replace("U", ""), 10) * 16;
                if (val.Item !== undefined) {
                    let ServerImgPath;
                    if (this.state.RackRearView) {
                        ServerImgPath = appUrl+"/img/SizingEngine/Images/GRE Images/";
                    } else {
                        ServerImgPath = "";
                    }
                    if (val["@EmptyImage"] == "C3000.gif") {
                        let topstyle, leftstyle, bottomstyle, widthStyle, heightStyle;
                        Server = val.Item.map((bladeServer) => {
                            let serverPosition = bladeServer["@BaysOccupied"]
                            if ((serverPosition.split('+')).length === 1) {
                                widthStyle = '50%';
                                heightStyle = '25%'
                                if (serverPosition == 1 || serverPosition == 5) {
                                    topstyle = '0px';
                                    bottomstyle = '';
                                    leftstyle = serverPosition == 1 ? '0%' : '50%'
                                } else if (serverPosition == 2 || serverPosition == 6) {
                                    topstyle = '25%';
                                    bottomstyle = '';
                                    leftstyle = serverPosition == 2 ? '0%' : '50%';
                                } else if (serverPosition == 3 || serverPosition == 7) {
                                    topstyle = '';
                                    bottomstyle = '25%';
                                    leftstyle = serverPosition == 3 ? '0%' : '50%';
                                } else {
                                    topstyle = '';
                                    bottomstyle = '0px';
                                    leftstyle = serverPosition == 4 ? '0%' : '50%';
                                }
                            }
                            else {
                                let serverPositionArray = serverPosition.split('+');
                                if (serverPositionArray.length === 2) {

                                    if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 1).toString()) === 1) {
                                        widthStyle = '50%'
                                        heightStyle = '50%'
                                    }
                                    else if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 4).toString()) === 1) {
                                        widthStyle = '100%'
                                        heightStyle = '25%'
                                    }
                                } else if (serverPositionArray.length === 4) {
                                    widthStyle = '100%'
                                    heightStyle = '50%'
                                }
                                if (serverPositionArray[0] == 1 || serverPositionArray[0] == 5) {
                                    topstyle = '0px';
                                    bottomstyle = '';
                                    leftstyle = serverPositionArray[0] == 1 ? '0%' : '50%'
                                } else if (serverPositionArray[0] == 2 || serverPositionArray[0] == 6) {
                                    topstyle = '25%';
                                    bottomstyle = '';
                                    leftstyle = serverPositionArray[0] == 2 ? '0%' : '50%';
                                } else if (serverPositionArray[0] == 3 || serverPositionArray[0] == 7) {
                                    topstyle = '';
                                    bottomstyle = '25%';
                                    leftstyle = serverPositionArray[0] == 3 ? '0%' : '50%';
                                } else {
                                    topstyle = '';
                                    bottomstyle = '0px';
                                    leftstyle = serverPositionArray[0] == 4 ? '0%' : '50%';
                                }
                            }
                            var AlignementCss = {
                                position: 'absolute', width: widthStyle, bottom: bottomstyle, top: topstyle, left: leftstyle, height: heightStyle
                            }
                            return (
                                <Box direction='row' justify='start' align='start' style={AlignementCss}>
                                    <Box direction='row' justify='start' align='start' id={bladeServer["@EmptyImage"].slice(0, -4)} className="ServerItemsHover" style={{ width: '100%', height: '100%', backgroundImage: 'url("' + ServerImgPath + bladeServer["@EmptyImage"] + '")' }} data-tip={this.GRHoverTextUpdate(bladeServer)} >
                                    </Box></Box>
                            )
                        })
                    }
                    else if (val["@EmptyImage"] == "Synergy 12000.gif" || val["@EmptyImage"] == "C7000.gif") {
                        let baysInaRow = 6;
                        let widthOfEachBay = 100 / 6;
                        if (val["@EmptyImage"] != "Synergy 12000.gif") {
                            baysInaRow = 8;
                            widthOfEachBay = 100 / 8;
                        }
                        let topstyle, leftstyle, bottomstyle, widthStyle, heightStyle;
                        Server = val.Item.map((synergyServer) => {
                            let serverPosition = synergyServer["@BaysOccupied"]
                            if ((serverPosition.split('+')).length === 1) {
                                widthStyle = (widthOfEachBay).toString() + '%';
                                heightStyle = '50%'
                                if (serverPosition <= baysInaRow) {
                                    topstyle = '0px';
                                    bottomstyle = '';
                                    leftstyle = ((serverPosition - 1) * widthOfEachBay).toString() + '%';
                                } else {
                                    topstyle = '';
                                    bottomstyle = '0px';
                                    leftstyle = ((serverPosition - baysInaRow - 1) * widthOfEachBay).toString() + '%';
                                }
                            }
                            else {
                                let serverPositionArray = serverPosition.split('+');
                                if (serverPositionArray.length === 2) {
                                    if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 1).toString()) === 1) {
                                        widthStyle = (widthOfEachBay * 2).toString() + '%';
                                        heightStyle = '50%'
                                    }
                                    else if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + baysInaRow).toString()) === 1) {
                                        widthStyle = (widthOfEachBay).toString() + '%'
                                        heightStyle = '100%'
                                    }
                                } else if (serverPositionArray.length === 4) {
                                    widthStyle = (widthOfEachBay * 2).toString() + '%'
                                    heightStyle = '100%'
                                }
                                if (serverPositionArray[0] <= baysInaRow) {
                                    topstyle = '0px';
                                    bottomstyle = '';
                                    leftstyle = ((serverPositionArray[0] - 1) * widthOfEachBay).toString() + '%';
                                } else {
                                    topstyle = '';
                                    bottomstyle = '0px';
                                    leftstyle = ((serverPositionArray[0] - baysInaRow - 1) * widthOfEachBay).toString() + '%';
                                }
                            }
                            var AlignementCss = {
                                position: 'absolute', width: widthStyle, bottom: bottomstyle, top: topstyle, left: leftstyle, height: heightStyle
                            }
                            return (
                                <Box direction='row' justify='start' align='start' style={AlignementCss}>
                                    <Box direction='row' justify='start' align='start' id={synergyServer["@EmptyImage"].slice(0, -4)} className="ServerItemsHover" style={{ width: '100%', height: '100%', backgroundImage: 'url("' + ServerImgPath + synergyServer["@EmptyImage"] + '")' }} data-tip={this.GRHoverTextUpdate(synergyServer)} >
                                    </Box></Box>
                            )
                        }
                        )
                    }
                }
                let ImgPathUrl = '';
                if (val["@EmptyImage"] === "C7000.gif" || val["@EmptyImage"] === "C3000.gif" || val["@EmptyImage"] === "Synergy 12000.gif") {
                    if (this.state.RackRearView) {
                        ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Enclosure/";

                    } else {
                        ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Rear View/"
                    }
                } else {
                    if (this.state.RackRearView) {
                        ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/";

                    } else {
                        ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Rear View/";
                    }
                }
                return (
                    <Box direction='row' justify='start' align='start' margin="none" pad="none" className="" style={{ height: InnerServrsHeight, width: '100%' }} >
                        <Box direction='row' justify='start' align='start' margin="none" pad="none" className="RackItemsHover" style={{ height: '100%', width: '4px', backgroundImage: 'url("'+appUrl+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")' }}> </Box>
                        <Box direction='row' justify='start' align='start' id={val["@EmptyImage"].slice(0, -4)} separator="top" className="12345" style={{ height: '100%', width: '100%', position: 'relative', Padding: '4px', backgroundImage: 'url("' + ImgPathUrl + val["@EmptyImage"] + '")', }} data-tip={this.GRHoverTextUpdate(val)}>
                            {Server}
                        </Box>
                        <Box direction='row' justify='start' align='start' className="RackItemsHover" margin="none" pad="none" style={{ height: '100%', width: '4px', backgroundImage: 'url("'+appUrl+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")' }}> </Box>
                    </Box>);
            });
        } else {
            let Server;
            var InnerServrsHeight = parseInt(FrontView.InnerLayers.InnerLayer["@Height"].replace("U", ""), 10) * 16;
            let ImgPathUrl = '';
            if (FrontView.InnerLayers.InnerLayer.Item !== undefined) {
                let ServerImgPath;
                if (this.state.RackRearView) {
                    ServerImgPath = appUrl+"/img/SizingEngine/Images/GRE Images/";
                } else {
                    ServerImgPath = "";
                }
                if (FrontView.InnerLayers.InnerLayer["@EmptyImage"] == "C3000.gif") {
                    var topstyle, leftstyle, bottomstyle, widthStyle, heightStyle;
                    Server = FrontView.InnerLayers.InnerLayer.Item.map((bladeServer) => {
                        let serverPosition = bladeServer["@BaysOccupied"]
                        if ((serverPosition.split('+')).length === 1) {
                            widthStyle = '50%';
                            heightStyle = '25%'
                            if (serverPosition == 1 || serverPosition == 5) {
                                topstyle = '0px';
                                bottomstyle = '';
                                leftstyle = serverPosition == 1 ? '0%' : '50%'
                            } else if (serverPosition == 2 || serverPosition == 6) {
                                topstyle = '25%';
                                bottomstyle = '';
                                leftstyle = serverPosition == 2 ? '0%' : '50%';
                            } else if (serverPosition == 3 || serverPosition == 7) {
                                topstyle = '';
                                bottomstyle = '25%';
                                leftstyle = serverPosition == 3 ? '0%' : '50%';
                            } else {
                                topstyle = '';
                                bottomstyle = '0px';
                                leftstyle = serverPosition == 4 ? '0%' : '50%';
                            }
                        }
                        else {
                            let serverPositionArray = serverPosition.split('+');
                            if (serverPositionArray.length === 2) {
                                if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 1).toString()) === 1) {
                                    widthStyle = '50%'
                                    heightStyle = '50%'
                                }
                                else if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 4).toString()) === 1) {
                                    widthStyle = '100%'
                                    heightStyle = '25%'
                                }
                            } else if (serverPositionArray.length === 4) {
                                widthStyle = '100%'
                                heightStyle = '50%'
                            }
                            if (serverPositionArray[0] == 1 || serverPositionArray[0] == 5) {
                                topstyle = '0px';
                                bottomstyle = '';
                                leftstyle = serverPositionArray[0] == 1 ? '0%' : '50%'
                            } else if (serverPositionArray[0] == 2 || serverPositionArray[0] == 6) {
                                topstyle = '25%';
                                bottomstyle = '';
                                leftstyle = serverPositionArray[0] == 2 ? '0%' : '50%';
                            } else if (serverPositionArray[0] == 3 || serverPositionArray[0] == 7) {
                                topstyle = '';
                                bottomstyle = '25%';
                                leftstyle = serverPositionArray[0] == 3 ? '0%' : '50%';
                            } else {
                                topstyle = '';
                                bottomstyle = '0px';
                                leftstyle = serverPositionArray[0] == 4 ? '0%' : '50%';
                            }
                        }
                        var AlignementCss = {
                            position: 'absolute', width: widthStyle, bottom: bottomstyle, top: topstyle, left: leftstyle, height: heightStyle
                        }
                        return (
                            <Box direction='row' justify='start' align='start' style={AlignementCss}>
                                <Box direction='row' justify='start' align='start' id={bladeServer["@EmptyImage"].slice(0, -4)} className="ServerItemsHover" style={{ width: '100%', height: '100%', backgroundImage: 'url("' + ServerImgPath + bladeServer["@EmptyImage"] + '")' }} data-tip={this.GRHoverTextUpdate(bladeServer)}>
                                </Box></Box>
                        )
                    })
                } else if (FrontView.InnerLayers.InnerLayer["@EmptyImage"] == "Synergy 12000.gif" || FrontView.InnerLayers.InnerLayer["@EmptyImage"] == "C7000.gif") {
                    let baysInaRow = 6;
                    let widthOfEachBay = 100 / 6;
                    if (FrontView.InnerLayers.InnerLayer["@EmptyImage"] != "Synergy 12000.gif") {
                        baysInaRow = 8;
                        widthOfEachBay = 100 / 8;
                    }
                    let topstyle, leftstyle, bottomstyle, widthStyle, heightStyle;
                    Server = FrontView.InnerLayers.InnerLayer.Item.map((synergyServer) => {
                        let serverPosition = synergyServer["@BaysOccupied"]
                        if ((serverPosition.split('+')).length === 1) {
                            widthStyle = (widthOfEachBay).toString() + '%';
                            heightStyle = '50%'
                            if (serverPosition <= baysInaRow) {
                                topstyle = '0px';
                                bottomstyle = '';
                                leftstyle = ((serverPosition - 1) * widthOfEachBay).toString() + '%';
                            } else {
                                topstyle = '';
                                bottomstyle = '0px';
                                leftstyle = ((serverPosition - baysInaRow - 1) * widthOfEachBay).toString() + '%';
                            }
                        }
                        else {
                            let serverPositionArray = serverPosition.split('+');
                            if (serverPositionArray.length === 2) {
                                if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + 1).toString()) === 1) {
                                    widthStyle = (widthOfEachBay * 2).toString() + '%';
                                    heightStyle = '50%'
                                }
                                else if (serverPositionArray.indexOf((parseInt(serverPositionArray[0], 10) + baysInaRow).toString()) === 1) {
                                    widthStyle = (widthOfEachBay).toString() + '%'
                                    heightStyle = '100%'
                                }
                            } else if (serverPositionArray.length === 4) {
                                widthStyle = (widthOfEachBay * 2).toString() + '%'
                                heightStyle = '100%'
                            }
                            if (serverPositionArray[0] <= baysInaRow) {
                                topstyle = '0px';
                                bottomstyle = '';
                                leftstyle = ((serverPositionArray[0] - 1) * widthOfEachBay).toString() + '%';
                            } else {
                                topstyle = '';
                                bottomstyle = '0px';
                                leftstyle = ((serverPositionArray[0] - baysInaRow - 1) * widthOfEachBay).toString() + '%';
                            }
                        }
                        var AlignementCss = {
                            position: 'absolute', width: widthStyle, bottom: bottomstyle, top: topstyle, left: leftstyle, height: heightStyle
                        }
                        return (
                            <Box direction='row' justify='start' align='start' style={AlignementCss}>
                                <Box direction='row' justify='start' align='start' id={synergyServer["@EmptyImage"].slice(0, -4)} className="ServerItemsHover" style={{ width: '100%', height: '100%', backgroundImage: 'url("' + ServerImgPath + synergyServer["@EmptyImage"] + '")' }} data-tip={this.GRHoverTextUpdate(synergyServer)}>
                                </Box></Box>
                        )
                    }
                    )
                }
            }
            if (FrontView.InnerLayers.InnerLayer["@EmptyImage"] === "C7000.gif" || FrontView.InnerLayers.InnerLayer["@EmptyImage"] === "C3000.gif" || FrontView.InnerLayers.InnerLayer["@EmptyImage"] === "Synergy 12000.gif") {
                if (this.state.RackRearView) {
                    ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Enclosure/";
                } else {
                    ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Rear View/"
                }
            } else {
                if (this.state.RackRearView) {
                    ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/"
                } else {
                    ImgPathUrl = appUrl+"/img/SizingEngine/Images/GRE Images/Rear View/"
                }
            }
            RacksInsideServers = <Box direction='row' justify='start' align='start' margin="none" pad="none" className="" style={{ height: InnerServrsHeight, width: '100%', }} >
                <Box direction='row' justify='start' align='start' margin="none" pad="none" className="RackItemsHover" style={{ height: '100%', width: '4px', backgroundImage: 'url("'+appUrl+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")' }}> </Box>
                <Box direction='row' data-tip={this.GRHoverTextUpdate(FrontView.InnerLayers.InnerLayer)} justify='start' align='start' className="idxse" separator="top" style={{ height: '100%', width: '100%', position: 'relative', Padding: '4px', backgroundImage: 'url("' + ImgPathUrl + FrontView.InnerLayers.InnerLayer["@EmptyImage"] + '")', }}>      {Server}
                </Box>
                <Box direction='row' justify='start' align='start' className="RackItemsHover" margin="none" pad="none" style={{ height: '100%', width: '4px', backgroundImage: 'url("'+appUrl+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")' }}> </Box>
            </Box>
        }
    }

    ZoomIn() {
        var ZoomScaleX = 0.05;
        $(".RackImageDisplay").css({ "marginTop": "150px", "marginLeft": "100px", margin: "100px" });
        if (this.state.scaleRadiusX === 1) {
            $(".RackImageDisplay").css({ "marginTop": "270px", "marginLeft": "100px" });
            this.setState({ scaleRadiusX: this.state.scaleRadiusX + ZoomScaleX, scaleRadiusY: this.state.scaleRadiusY, MinRackHeight: this.state.MinRackHeight, disabledZoomOut: false });
        }

        else if (this.state.scaleRadiusX > 1) {
        }
        else if (this.state.scaleRadiusX === 0.8) {
            $(".RackImageDisplay").css({ "marginTop": "270px", "marginLeft": "100px" });
            this.setState({ scaleRadiusX: this.state.scaleRadiusX = 1, scaleRadiusY: this.state.scaleRadiusY, MinRackHeight: this.state.MinRackHeight + 50, disabledZoomOut: false });
        }
        else {
            this.setState({ scaleRadiusX: this.state.scaleRadiusX + ZoomScaleX, scaleRadiusY: this.state.scaleRadiusY, MinRackHeight: this.state.MinRackHeight + 50, disabledZoomOut: false });
        }

    }
    ZoomOut() {
        var ZoomScaleX = 0.2;
        if (this.state.scaleRadiusX < 0.9) {


        } else {
            this.setState({ scaleRadiusX: this.state.scaleRadiusX - ZoomScaleX, MinRackHeight: this.state.MinRackHeight - 50, scaleRadiusY: this.state.scaleRadiusY });
        }
    }
    componentWillMount() {
        this.state.ActiveSite = this.props.PassActiveSite["@SiteID"];
        /* Static GRinput file */
        //this.state.GrInputRearView= GRInputRack.GraphicalInputs;
        /* dynamic GRinput file */

        this.state.GrInputRearView = this.props.activeSession.GRInput;
        this.RackInsideServers();
    }
    RackInsideServers() {

        if (this.state.GrInputRearView.OuterLayer.length > 1 && this.state.GrInputRearView.OuterLayer[1]["@Site"] == this.state.GrInputRearView.OuterLayer[0]["@Site"]) {
            RacksDisplaying = this.state.GrInputRearView.OuterLayer.map((Rackitem, id) => {
                this.OuterLayerLoop(id);
                let RackHeight = parseInt(Rackitem["@Height"].replace("U", ""), 10) * 17.4;
                let RackInnerHeight = parseInt(Rackitem["@Height"].replace("U", ""), 10) * 16;
                let idname = "Rackitem" + id.toString()
                return (
                    /*Change by Vinay, removed width for colliding rack images issue in I.E Browser*/
                    <Box margin="small" pad="none" id={idname} className="RackImageDisplay" style={{ /* width: '200px', */marginTop: '100px', transform: 'scale(' + this.state.scaleRadiusX + ',' + this.state.scaleRadiusX + ')' }}>
                        <Heading strong={true} align='center' uppercase={false} truncate={false} tag='h4' style={{ paddingTop: '88px' }}>{Rackitem["@Name"]} </Heading>
                        <Box justify='center' pad="none" margin="small" align='center' style={{ width: '200px', height: RackHeight + 'px', transform: 'scale(' + this.state.scaleRadiusX + ',' + this.state.scaleRadiusX + ')', transition: 'all 0.5s ease-in-out', backgroundImage: 'url("'+appUrl+"img/SizingEngine/Images/GRE Images/"+FrontView["@OuterLayerImage"]+'")' }}>
                            <Box align='end' pad="none" margin="none" reverse={true} style={{ height: RackInnerHeight, width: '77%', margin: 'auto', backgroundImage: 'url("'+appUrl+'img/SizingEngine/Images/GRE Images/Blank.png")', marginBottom: '4%', marginTop: '3%' }}>
                                <Box align='end' reverse={true} className="" style={{ height: RackInnerHeight, width: '100%', margin: 'auto', marginBottom: '10px' }}>
                                    {RacksInsideServers}
                                </Box>
                            </Box>
                        </Box>  </Box>);

            });

        } else {

            var data = this.state.GrInputRearView.OuterLayer;
            if (Array.isArray(data)) {
                this.OuterLayerLoop(0);
                FrontView = this.state.GrInputRearView.OuterLayer[0];
            } else {
                this.OuterLayerLoop();
                if (this.props.PassActiveSite["@SiteID"] == undefined) {
                    FrontView = this.state.GrInputRearView.OuterLayer
                } else {
                    FrontView = this.state.GrInputRearView.OuterLayer[this.props.PassActiveSite["@SiteID"]];
                }
            }

            RackHeight = parseInt(FrontView["@Height"].replace("U", ""), 10) * 17.4;
            RackInnerHeight = parseInt(FrontView["@Height"].replace("U", ""), 10) * 16;
            /*Change by Vinay, removed width for colliding rack images issue in I.E Browser*/
            RacksDisplaying = <Box margin="small" pad="none" id="Rackitem0" className="RackImageDisplay" style={{ width: '200px', marginTop: '100px' }}>
                <Heading strong={true} align='center' uppercase={false} truncate={false} tag='h4'>{FrontView["@Name"]} </Heading>
                <Box justify='center' pad="none" margin="small" align='center' style={{ width: '100%', height: RackHeight + 'px', transform: 'scale(' + this.state.scaleRadiusX + ',' + this.state.scaleRadiusX + ')', transition: 'all 0.5s ease-in-out', backgroundImage:'url("'+appUrl+"img/SizingEngine/Images/GRE Images/"+FrontView["@OuterLayerImage"]+'")'}}>
                    <Box align='end' pad="none" margin="none" reverse={true} style={{ height: RackInnerHeight + 'px', width: '77%', margin: 'auto', backgroundImage: 'url("'+appUrl.toString()+'img/SizingEngine/Images/GRE Images/Blank.png")', marginBottom: '4%', marginTop: '3%' }}>
                        <Box align='end' reverse={true} style={{ height: RackInnerHeight, width: '100%', margin: 'auto', marginBottom: '10px' }}>
                            {RacksInsideServers}
                        </Box>
                    </Box>
                </Box>
            </Box>
        }
        RackServersPresentation = <Box direction='row' id="captures" justify='center' align='center' style={{ width: '100%', minHeight: this.state.MinRackHeight + 'px', maxHeight: '900px', position: 'relative' }} >
            <Box direction="row" justify='left' align='end' style={{ width: '100%' }}>
                {RacksDisplaying}
            </Box>
        </Box>
    }
    RevertBack() {
        this.props.RackserverView(true);
    }
    RearView() {

        if (!this.state.RackRearView) {
            this.setState({ ViewLabelbtn: 'Rear View', RackRearView: true });
        } else {
            this.setState({ ViewLabelbtn: 'Front View', RackRearView: false });
        }
    }




    render() {
        var RackDet = this.props.activeSession.GRInput;
        HoverTitleStyle = {
            color: 'black', width: 'auto', height: 'auto', padding: '2px 4px', position: 'absolute', top: EventTopspace - 10 + 'px', left: EventLeftspace - 10 + 'px', zIndex: '220', backgroundColor: '#cccccc', border: ''
        }
        if (this.state.rackNoteDisplay === true) {
            RackNote = <Paragraph style={{ color: "red", margin: "10px", maxWidth: '100%', fontSize: '15px' }}>
                Note: The above graphical representation gives an overall idea about Rack and its components. The actual positioning/placement may vary depending on the user needs. 
                </Paragraph>
        } else {
            RackNote = " "
        }

        this.RackInsideServers();


        if (this.state.RackRearView) {
            RearviewHOverItems = this.state.TitleDisplay ? <Box margin="none" pad="none" style={HoverTitleStyle} >{this.state.ServerItemName}</Box> : <Box></Box>
        } else {
            RearviewHOverItems = "";
        }
        let wdth = '100%'
        if (_said === "EPAvNext") {
            wdth = '75%'
        }
        let PDFloadingLayer = ""
        if (this.props.isLoading) {
            PDFloadingLayer = <Layer className="PDFlayer" style={{ zIndex: '1000002 !important' }}>
                <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                    <Spinning size='small' style={{ color: "#fff" }} />
                    <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{this.props.LoadingMsg}</Heading>
                </Box>
            </Layer>
        }
        return (
            <Box margin="none" pad="none" className="GrTabSection" justify='start' align='center' style={{ height: '100%', width: '100%' }}>
                <ReactTooltip style={{ height: '100%' }} />
                {PDFloadingLayer}
                <Box direction='row' margin="none" pad="none" className="GrTabSection" justify='start' align='center' style={{ height: '90%', width: '100%' }}>
                    <Box margin="none" pad="none" justify='start' align='start' separator="right" style={{ height: '100%', width: '25%' }}>
                        <Box className="SolutionConfigAccordian" justify='start' margin="none" pad="none" align='start' style={{ height: '100%' }}>
                            <RackDetails MapContent={RackDet.OuterLayer} summary={RackDet.ConsolidateRack}/>
                        </Box>
                    </Box> 
                    <Box className="HrSecPres" margin="none" pad="small" justify='center' align='start' style={{ width: wdth }}>
                        <Box direction='row' margin="none" pad="small" justify='center' style={{ minHeight: '400px', maxHeight: '700px', width: '100%', overflow: 'auto' }} >
                            {RearviewHOverItems}
                            {RackServersPresentation}
                        </Box>
                    </Box>
                </Box>
                <Box direction='row' style={{ alignSelf: 'baseline', width: '100%', height: '10%' }}>
                    <Box margin="none" pad="none" justify='start' align='start' basis="1/4" style={{ height: '100%' }}>
                        <Box separator="bottom" direction='row' margin="none" justify='start' className="ZoomSectionBtns" style={{ width: '100%' }}>
                            {this.props.isFromExternalApp ? '' :
                            <Button icon={<Print size="small" colorIndex="accent-3" />} data-tip={'Print'} primary={false} onClick={this.PrintImage} /> }                            
                            <Button icon={<Save size="small" colorIndex="accent-3" />} data-tip={'Export to PDF'} primary={false} onClick={() => this.downloadPDF("pdf")} />
                            {/*href= {serviceUrl + "SizingEngine/GenerateGRpdf?&sessionId=" + this.props.activeSession.id + "&name="+pdfName} target="blank" */}
                            {/* {this.props.isFromExternalApp ? '' : */}
                            <Button icon={<ZoomIn size="small" colorIndex="accent-3" />} data-tip={'Zoom in'} primary={false} disabled={this.state.disabledZoomIn} onClick={this.ZoomIn} />
                            {/* } */}
                            {/* {this.props.isFromExternalApp ? '' : */}
                            <Button icon={<ZoomOut size="small" colorIndex="accent-3" />} data-tip={'Zoom out'} primary={false} disabled={this.state.disabledZoomOut} onClick={this.ZoomOut} />
                            {/* } */}
                            <Button icon={<Revert size="small" colorIndex="accent-3" />} data-tip={'Back'} primary={false} onClick={this.RevertBack} />
                            <Button icon={<OverviewIcon size="small" colorIndex="accent-3" />} data-tip={this.state.ViewLabelbtn} primary={false} onClick={this.RearView} />
                        </Box>
                    </Box>
                    <Box margin="none" pad="none" justify='start' align='start' basis="3/4" style={{ height: '100%' }}>
                        {RackNote}
                    </Box>

                </Box>

            </Box>





        );
    }
}
const mapStateToProps = (state) => {
    return {
        activeSession: state.sessions.activeSession,
        isLoading: state.sessions.isLoading,
        LoadingMsg: state.sessions.LoadingMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onfetchGRinput: (sessionID) => {
            dispatch(fetchGRinput(sessionID));
        },
        onPDFExport: (data) => {
            dispatch(downloadFile(data))
        }
    };
};
//export default GrRackServerPresentation;
export default connect(mapStateToProps, mapDispatchToProps)(GrRackServerInnerPresentation);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/GrRackServerInnerPresentation.js